import React from "react";
import "./Modal.css"; // Create a separate CSS file for the modal styling

const Modal = ({ show, handleClose }) => {
  return (
    show && (
      <div className="modal-overlay">
        <div className="modal-content">
          <h2>Welcome to DevComputers!</h2>
          <p className="mt-4">
            Checkout our <b>Products</b>?
          </p>

          <div className="row">
            <div className="col-lg-6">
              <a href="/websitedesign"><button className="btn btn-primary w-100">
                Our Products
              </button></a>
              
            </div>

            <div className="col-lg-6 col-md-6">
              <button className="btn btn-danger w-100" onClick={handleClose}>
                Close
              </button>
            </div>
          </div>
        </div>
      </div>
    )
  );
};

export default Modal;
